import { cva } from '@/styled-system/css';

export const avatarBadgeRecipe = cva({
  base: {
    position: 'absolute',
    boxSizing: 'border-box',
  },
  variants: {
    tone: {
      bare: {
        backgroundColor: 'transparent.invisible',
        border: 'none',
      },
      hero: {
        backgroundColor: 'Avatar.Badge.hero.bg',
        color: 'Avatar.Badge.hero.icon',
        boxShadowColor: 'Avatar.Badge.hero.border',
      },
      impact: {
        backgroundColor: 'Avatar.Badge.impact.bg',
        color: 'Avatar.Badge.impact.icon',
        boxShadowColor: 'Avatar.Badge.impact.border',
      },
    },
    size: {
      xs: {},
      sm: {},
      md: {},
      lg: {
        bottom: 'calc( -1 * {spacing.Avatar.Badge.offset.sm.vert})',
        right: 'calc( -1 * {spacing.Avatar.Badge.offset.sm.horz})',
      },
      xl: {
        bottom: 'calc( -1 * {spacing.Avatar.Badge.offset.md.vert})',
        right: 'calc( -1 * {spacing.Avatar.Badge.offset.md.horz})',
      },
      xxl: {
        bottom: 'calc( -1 * {spacing.Avatar.Badge.offset.lg.vert})',
        right: 'calc( -1 * {spacing.Avatar.Badge.offset.lg.horz})',
      },
    },
  },
  compoundVariants: [
    {
      size: 'lg',
      tone: ['hero', 'impact'],
      css: {
        'borderRadius': 'Avatar.Badge.sm',
        'boxShadow': 'inset 0 0 0 {borderWidths.Avatar.Badge.sm} var(--shadow-color)',
        'padding': 'Avatar.Badge.padding.sm.default',
        '& > [data-c11n-component="Icon"]': {
          width: 'Avatar.Badge.sm.icon.default',
          height: 'Avatar.Badge.sm.icon.default',
        },
      },
    },
    {
      size: 'xl',
      tone: ['hero', 'impact'],
      css: {
        'borderRadius': 'Avatar.Badge.md',
        'boxShadow': 'inset 0 0 0 {borderWidths.Avatar.Badge.md} var(--shadow-color)',
        'padding': 'Avatar.Badge.padding.md.default',
        '& > [data-c11n-component="Icon"]': {
          width: 'Avatar.Badge.md.icon.default',
          height: 'Avatar.Badge.md.icon.default',
        },
      },
    },
    {
      size: 'xxl',
      tone: ['hero', 'impact'],
      css: {
        'borderRadius': 'Avatar.Badge.lg',
        'boxShadow': 'inset 0 0 0 {borderWidths.Avatar.Badge.lg} var(--shadow-color)',
        'padding': 'Avatar.Badge.padding.lg.default',
        '& > [data-c11n-component="Icon"]': {
          width: 'Avatar.Badge.lg.icon.default',
          height: 'Avatar.Badge.lg.icon.default',
        },
      },
    },
    {
      size: 'lg',
      tone: 'bare',
      css: {
        'padding': 'Avatar.Badge.padding.sm.bare',
        '& > [data-c11n-component="Icon"]': {
          width: 'Avatar.Badge.sm.icon.bare',
          height: 'Avatar.Badge.sm.icon.bare',
        },
      },
    },
    {
      size: 'xl',
      tone: 'bare',
      css: {
        'padding': 'Avatar.Badge.padding.md.bare',
        '& > [data-c11n-component="Icon"]': {
          width: 'Avatar.Badge.md.icon.bare',
          height: 'Avatar.Badge.md.icon.bare',
        },
      },
    },
    {
      size: 'xxl',
      tone: 'bare',
      css: {
        'padding': 'Avatar.Badge.padding.lg.bare',
        '& > [data-c11n-component="Icon"]': {
          width: 'Avatar.Badge.lg.icon.bare',
          height: 'Avatar.Badge.lg.icon.bare',
        },
      },
    },
    {
      size: ['xs', 'sm', 'md'],
      css: {
        display: 'none',
      },
    },
    {
      size: ['lg', 'xl', 'xxl'],
      css: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
  ],
});
